import React, { useEffect, useState } from 'react';
import KpiListService from '../../setting/kpiList/KpiListService';
import { toast } from 'react-toastify';

const AdminKpiListView = () => {
  const [kpiLists, setKpiLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await KpiListService.getKpiListsView();
        const all = Array.isArray(res.data) ? res.data : [];
        setKpiLists(all.filter((item) => item.isActive));
      } catch (err) {
        toast.error(err?.response?.data?.message || 'โหลดรายการ KPI ไม่สำเร็จ');
        setKpiLists([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mt-4 flex flex-col">
        <div className="mb-4">
          <h2 className="text-5xl">ดูรายการ KPI</h2>
          <p className="mt-2 text-gray-600">รายการ KPI ที่ใช้งานอยู่และคะแนนที่หัก (ดูได้อย่างเดียว)</p>
        </div>
        <div className="shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg overflow-hidden">
          <div className="overflow-x-auto" style={{ maxHeight: 'calc(100vh - 220px)' }}>
            {loading ? (
              <div className="p-8 text-center text-gray-500">กำลังโหลด...</div>
            ) : (
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50 sticky top-0 z-0">
                  <tr>
                    <th scope="col" className="py-4 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      No
                    </th>
                    <th scope="col" className="px-3 py-4 text-left text-sm font-semibold text-gray-900">
                      Group
                    </th>
                    <th scope="col" className="px-3 py-4 text-left text-sm font-semibold text-gray-900">
                      Topic
                    </th>
                    <th scope="col" className="px-3 py-4 text-left text-sm font-semibold text-gray-900">
                      Detail
                    </th>
                    <th scope="col" className="px-3 py-4 text-left text-sm font-semibold text-gray-900">
                      Deduct Point
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {kpiLists.map((item, index) => (
                    <tr key={item.id}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {index + 1}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">
                        {item.group || '-'}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">
                        {item.topic || '-'}
                      </td>
                      <td className="px-3 py-4 text-sm text-gray-700 max-w-md">
                        {item.detail || '-'}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm font-medium text-gray-900">
                        {item.deductPoint != null ? item.deductPoint : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {!loading && kpiLists.length === 0 && (
            <div className="p-8 text-center text-gray-500">ไม่มีรายการ KPI</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminKpiListView;
